import { render } from "./TInputSelect.vue?vue&type=template&id=89f7eef4&scoped=true"
import script from "./TInputSelect.vue?vue&type=script&lang=js"
export * from "./TInputSelect.vue?vue&type=script&lang=js"

import "./TInputSelect.vue?vue&type=style&index=0&id=89f7eef4&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f7eef4"]])

export default __exports__